export const STEPS_STATES = {
  INITIAL: 'initial',
  IN_PROGRESS: 'inProgress',
  COMPLETED: 'completed',
};
